const BluetoothPrinter = () => {
  const connectAndPrint = async () => {
    try {
      const device = await navigator.bluetooth.requestDevice({
        acceptAllDevices: true,
        optionalServices: [0x1101], // may vary by printer
      });

      const server = await device.gatt.connect();
      const service = await server.getPrimaryService(0x1101);

      // This UUID depends on your printer, many use FFE1
      const characteristic = await service.getCharacteristic(
        "0000ffe1-0000-1000-8000-00805f9b34fb"
      );

      const encoder = new TextEncoder();
      const data = encoder.encode("Hello Bluetooth Printer\n\n\n");
      await characteristic.writeValue(data);

      alert("Printed successfully!");
    } catch (err) {
      console.error("Bluetooth print failed:", err);
      alert("Could not print: " + err);
    }
  };

  return (
    <div>
      <h2>Bluetooth Printer Test</h2>
      <button onClick={connectAndPrint}>Connect & Print</button>
    </div>
  );
};

export default BluetoothPrinter;
